export const EXPORT_TYPE_OPTION_VALUES = {
  table: 'table',
  string: 'string',
};

export const SHOW_HEADER_ROW_OPTION_VALUES = {
  show: true,
  hide: false,
};

export const PERIOD_OPTION_VALUES = {
  today: 'today',
  yesterday: 'yesterday',
  this_week_beginning_on_monday: 'this_week_beginning_on_monday',
  this_week_beginning_on_sunday: 'this_week_beginning_on_sunday',
  last_week_beginning_on_monday: 'last_week_beginning_on_monday',
  last_week_beginning_on_sunday: 'last_week_beginning_on_sunday',
  last_7d: 'last_7d',
  last_7d_upto_yesterday: 'last_7d_upto_yesterday',
  last_30d: 'last_30d',
  last_30d_upto_yesterday: 'last_30d_upto_yesterday',
  last_90d: 'last_90d',
  last_90d_upto_yesterday: 'last_90d_upto_yesterday',
  this_month: 'this_month',
  last_month: 'last_month',
  last_2m: 'last_2m',
  last_2m_upto_last_month: 'last_2m_upto_last_month',
  last_3m: 'last_3m',
  last_3m_upto_last_month: 'last_3m_upto_last_month',
  last_13m: 'last_13m',
  last_13m_upto_last_month: 'last_13m_upto_last_month',
  this_year: 'this_year',
  custom_period: 'custom_period',
};

export const OVER_PERIOD_THRESHOLD_DAYS_VALUES = [
  PERIOD_OPTION_VALUES.last_13m,
  PERIOD_OPTION_VALUES.last_13m_upto_last_month,
  PERIOD_OPTION_VALUES.this_year,
];

export const AGGREGATION_AXIS_COLUMN_VALUES = {
  projectId: 'project_id',
  projectName: 'project_name',
  channel: 'channel',
  adAccountName: 'ad_account_name',
  adCampaignName: 'ad_campaign_name',
  adGroupName: 'ad_group_name',
  adName: 'ad_name',
  accountRemoteId: 'account_remote_id',
  campaignRemoteId: 'campaign_remote_id',
  adGroupRemoteId: 'ad_group_remote_id',
  adRemoteId: 'ad_remote_id',
  adCampaignObjective: 'ad_campaign_objective',
  searchQuery: 'search_query',
  keywordText: 'keyword_text',
  keywordRemoteId: 'keyword_remote_id',
  keywordStatus: 'keyword_status',
  keywordMatchType: 'keyword_match_type',
  matchType: 'match_type',
  keywordIncludeExclude: 'keyword_include_exclude',
  adType: 'creative_type',
  videoUrl: 'video_url',
  thumbnailImageUrl: 'thumbnail_image_url',
  originalImageUrl: 'original_image_url',
  thumbnailImage: 'thumbnail_image_img',
  originalImage: 'original_image_img',
  text1: 'text1',
  text2: 'text2',
  cta: 'cta',
  ctaLinkUrlWoParams: 'cta_link_url_wo_param',
  ctaLinkUrl: 'cta_link_url',
  hour: 'hour',
  gender: 'gender',
  age: 'age',
  network: 'platform',
  placement: 'delivery_side',
  country: 'country',
  prefecture: 'prefecture',
  deviceCategory: 'device_category',
  device: 'device',
  reportType: 'report_type',
  category01: 'category_01',
  category02: 'category_02',
  month: 'month',
  day: 'day',
  wday: 'wday',
};

export const ADVERTISING_TITLE_COLUMN_VALUES = {
  cpm: 'cpm',
  cpc: 'cpc',
  impressions: 'impressions',
  ctr: 'ctr',
  clicks: 'clicks',
  spend: 'spend',
};

export const OTHER_COLUMN_VALUES = {
  blank: 'blank',
};

export const AGGREGATION_AXIS_COLUMN_GROUP_KEYS = {
  always: 'always',
  searchTerm: 'searchTerm',
  adStructure: 'adStructure',
  creativeAsset: 'creativeAsset',
  hour: 'hour',
  gender: 'gender',
  age: 'age',
  network: 'network',
  geography: 'geography',
  device: 'device',
  classification: 'classification',
};

export const AGGREGATION_AXIS_COLUMN_GROUPS = {
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.always]: [
    AGGREGATION_AXIS_COLUMN_VALUES.projectId,
    AGGREGATION_AXIS_COLUMN_VALUES.projectName,
    AGGREGATION_AXIS_COLUMN_VALUES.channel,
    AGGREGATION_AXIS_COLUMN_VALUES.adAccountName,
    AGGREGATION_AXIS_COLUMN_VALUES.adCampaignName,
    AGGREGATION_AXIS_COLUMN_VALUES.adGroupName,
    AGGREGATION_AXIS_COLUMN_VALUES.accountRemoteId,
    AGGREGATION_AXIS_COLUMN_VALUES.campaignRemoteId,
    AGGREGATION_AXIS_COLUMN_VALUES.adGroupRemoteId,
    AGGREGATION_AXIS_COLUMN_VALUES.adCampaignObjective,
    AGGREGATION_AXIS_COLUMN_VALUES.month,
    AGGREGATION_AXIS_COLUMN_VALUES.day,
    AGGREGATION_AXIS_COLUMN_VALUES.wday,
  ],
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.searchTerm]: [
    AGGREGATION_AXIS_COLUMN_VALUES.searchQuery,
    AGGREGATION_AXIS_COLUMN_VALUES.keywordText,
    AGGREGATION_AXIS_COLUMN_VALUES.keywordRemoteId,
    AGGREGATION_AXIS_COLUMN_VALUES.keywordStatus,
    AGGREGATION_AXIS_COLUMN_VALUES.keywordMatchType,
    AGGREGATION_AXIS_COLUMN_VALUES.matchType,
    AGGREGATION_AXIS_COLUMN_VALUES.keywordIncludeExclude,
  ],
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.adStructure]: [
    AGGREGATION_AXIS_COLUMN_VALUES.adName,
    AGGREGATION_AXIS_COLUMN_VALUES.adRemoteId,
  ],
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.creativeAsset]: [
    AGGREGATION_AXIS_COLUMN_VALUES.adType,
    AGGREGATION_AXIS_COLUMN_VALUES.videoUrl,
    AGGREGATION_AXIS_COLUMN_VALUES.thumbnailImageUrl,
    AGGREGATION_AXIS_COLUMN_VALUES.originalImageUrl,
    AGGREGATION_AXIS_COLUMN_VALUES.thumbnailImage,
    AGGREGATION_AXIS_COLUMN_VALUES.originalImage,
    AGGREGATION_AXIS_COLUMN_VALUES.text1,
    AGGREGATION_AXIS_COLUMN_VALUES.text2,
    AGGREGATION_AXIS_COLUMN_VALUES.cta,
    AGGREGATION_AXIS_COLUMN_VALUES.ctaLinkUrlWoParams,
    AGGREGATION_AXIS_COLUMN_VALUES.ctaLinkUrl,
  ],
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.hour]: [
    AGGREGATION_AXIS_COLUMN_VALUES.hour,
  ],
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.gender]: [
    AGGREGATION_AXIS_COLUMN_VALUES.gender,
  ],
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.age]: [
    AGGREGATION_AXIS_COLUMN_VALUES.age,
  ],
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.network]: [
    AGGREGATION_AXIS_COLUMN_VALUES.network,
    AGGREGATION_AXIS_COLUMN_VALUES.placement,
  ],
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.geography]: [
    AGGREGATION_AXIS_COLUMN_VALUES.country,
    AGGREGATION_AXIS_COLUMN_VALUES.prefecture,
  ],
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.device]: [
    AGGREGATION_AXIS_COLUMN_VALUES.deviceCategory,
    AGGREGATION_AXIS_COLUMN_VALUES.device,
  ],
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.classification]: [
    AGGREGATION_AXIS_COLUMN_VALUES.reportType,
    AGGREGATION_AXIS_COLUMN_VALUES.category01,
    AGGREGATION_AXIS_COLUMN_VALUES.category02,
  ],
};

export const AGGREGATION_AXIS_COLUMN_TO_GROUP_MAP = Object.entries(
  AGGREGATION_AXIS_COLUMN_GROUPS
).reduce((acc, [groupKey, columnValues]) => {
  columnValues.forEach((columnValue) => {
    acc[columnValue] = groupKey;
  });
  return acc;
}, {});

export const getAggregationAxisColumnGroupKey = (columnValue) =>
  AGGREGATION_AXIS_COLUMN_TO_GROUP_MAP[columnValue] || null;

const EXCLUSIVE_AGGREGATION_AXIS_GROUPS = [
  AGGREGATION_AXIS_COLUMN_GROUP_KEYS.hour,
  AGGREGATION_AXIS_COLUMN_GROUP_KEYS.gender,
  AGGREGATION_AXIS_COLUMN_GROUP_KEYS.age,
  AGGREGATION_AXIS_COLUMN_GROUP_KEYS.network,
  AGGREGATION_AXIS_COLUMN_GROUP_KEYS.geography,
  AGGREGATION_AXIS_COLUMN_GROUP_KEYS.device,
  AGGREGATION_AXIS_COLUMN_GROUP_KEYS.classification,
];

export const AGGREGATION_AXIS_COLUMN_GROUP_CONFLICTS = {
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.searchTerm]: [
    AGGREGATION_AXIS_COLUMN_GROUP_KEYS.adStructure,
    AGGREGATION_AXIS_COLUMN_GROUP_KEYS.creativeAsset,
    ...EXCLUSIVE_AGGREGATION_AXIS_GROUPS,
  ],
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.adStructure]: [
    AGGREGATION_AXIS_COLUMN_GROUP_KEYS.searchTerm,
  ],
  [AGGREGATION_AXIS_COLUMN_GROUP_KEYS.creativeAsset]: [
    AGGREGATION_AXIS_COLUMN_GROUP_KEYS.searchTerm,
  ],
  ...Object.fromEntries(
    EXCLUSIVE_AGGREGATION_AXIS_GROUPS.map((groupKey) => [
      groupKey,
      [
        AGGREGATION_AXIS_COLUMN_GROUP_KEYS.searchTerm,
        ...EXCLUSIVE_AGGREGATION_AXIS_GROUPS.filter(
          (conflictKey) => conflictKey !== groupKey
        ),
      ],
    ])
  ),
};

const addGroupKeyFromColumnValue = (set, columnValue) => {
  const groupKey = getAggregationAxisColumnGroupKey(columnValue);
  if (groupKey && groupKey !== AGGREGATION_AXIS_COLUMN_GROUP_KEYS.always) {
    set.add(groupKey);
  }
};

export const getSelectedAggregationAxisGroupKeys = ({
  columns = [],
  filters = [],
} = {}) => {
  const selectedGroupKeys = new Set();

  columns.forEach((column) =>
    addGroupKeyFromColumnValue(selectedGroupKeys, column?.content)
  );

  filters.forEach((andGroup) => {
    if (!Array.isArray(andGroup)) return;

    andGroup.forEach((condition) =>
      addGroupKeyFromColumnValue(selectedGroupKeys, condition?.targetColumn)
    );
  });

  return Array.from(selectedGroupKeys);
};

export const getConflictingAggregationAxisGroupKeys = (
  selectedGroupKeys = []
) => {
  const selectedSet = new Set(selectedGroupKeys);
  const conflictingGroupKeys = new Set();

  selectedGroupKeys.forEach((groupKey) => {
    (AGGREGATION_AXIS_COLUMN_GROUP_CONFLICTS[groupKey] || []).forEach(
      (conflictKey) => {
        if (!selectedSet.has(conflictKey)) {
          conflictingGroupKeys.add(conflictKey);
        }
      }
    );
  });

  return Array.from(conflictingGroupKeys);
};

export const getConflictingAggregationAxisColumns = ({
  columns = [],
  filters = [],
} = {}) => {
  const selectedGroupKeys = getSelectedAggregationAxisGroupKeys({
    columns,
    filters,
  });

  const conflictingGroupKeys =
    getConflictingAggregationAxisGroupKeys(selectedGroupKeys);

  const disabledColumns = new Set();

  conflictingGroupKeys.forEach((groupKey) => {
    (AGGREGATION_AXIS_COLUMN_GROUPS[groupKey] || []).forEach((columnValue) =>
      disabledColumns.add(columnValue)
    );
  });

  return Array.from(disabledColumns);
};

export const OVER_PERIOD_THRESHOLD_DAYS_DISABLED_AGGREGATION_AXIS_COLUMNS = [
  AGGREGATION_AXIS_COLUMN_VALUES.adRemoteId,
  AGGREGATION_AXIS_COLUMN_VALUES.searchQuery,
  AGGREGATION_AXIS_COLUMN_VALUES.keywordText,
  AGGREGATION_AXIS_COLUMN_VALUES.keywordRemoteId,
  AGGREGATION_AXIS_COLUMN_VALUES.keywordStatus,
  AGGREGATION_AXIS_COLUMN_VALUES.keywordMatchType,
  AGGREGATION_AXIS_COLUMN_VALUES.matchType,
  AGGREGATION_AXIS_COLUMN_VALUES.keywordIncludeExclude,
  AGGREGATION_AXIS_COLUMN_VALUES.adType,
  AGGREGATION_AXIS_COLUMN_VALUES.videoUrl,
  AGGREGATION_AXIS_COLUMN_VALUES.thumbnailImageUrl,
  AGGREGATION_AXIS_COLUMN_VALUES.originalImageUrl,
  AGGREGATION_AXIS_COLUMN_VALUES.thumbnailImage,
  AGGREGATION_AXIS_COLUMN_VALUES.originalImage,
  AGGREGATION_AXIS_COLUMN_VALUES.text1,
  AGGREGATION_AXIS_COLUMN_VALUES.text2,
  AGGREGATION_AXIS_COLUMN_VALUES.cta,
  AGGREGATION_AXIS_COLUMN_VALUES.ctaLinkUrlWoParams,
  AGGREGATION_AXIS_COLUMN_VALUES.ctaLinkUrl,
  AGGREGATION_AXIS_COLUMN_VALUES.hour,
  AGGREGATION_AXIS_COLUMN_VALUES.gender,
  AGGREGATION_AXIS_COLUMN_VALUES.age,
  AGGREGATION_AXIS_COLUMN_VALUES.network,
  AGGREGATION_AXIS_COLUMN_VALUES.placement,
  AGGREGATION_AXIS_COLUMN_VALUES.country,
  AGGREGATION_AXIS_COLUMN_VALUES.prefecture,
  AGGREGATION_AXIS_COLUMN_VALUES.deviceCategory,
  AGGREGATION_AXIS_COLUMN_VALUES.device,
  AGGREGATION_AXIS_COLUMN_VALUES.reportType,
  AGGREGATION_AXIS_COLUMN_VALUES.category01,
  AGGREGATION_AXIS_COLUMN_VALUES.category02,
  AGGREGATION_AXIS_COLUMN_VALUES.day,
  AGGREGATION_AXIS_COLUMN_VALUES.wday,
];

export const UNSELECTABLE_FILTER_COLUMNS = [
  AGGREGATION_AXIS_COLUMN_VALUES.projectId,
  AGGREGATION_AXIS_COLUMN_VALUES.projectName,
  AGGREGATION_AXIS_COLUMN_VALUES.hour,
  AGGREGATION_AXIS_COLUMN_VALUES.age,
  AGGREGATION_AXIS_COLUMN_VALUES.network,
  AGGREGATION_AXIS_COLUMN_VALUES.placement,
  AGGREGATION_AXIS_COLUMN_VALUES.country,
  AGGREGATION_AXIS_COLUMN_VALUES.deviceCategory,
  AGGREGATION_AXIS_COLUMN_VALUES.device,
  AGGREGATION_AXIS_COLUMN_VALUES.thumbnailImage,
  AGGREGATION_AXIS_COLUMN_VALUES.originalImage,
  AGGREGATION_AXIS_COLUMN_VALUES.reportType,
  AGGREGATION_AXIS_COLUMN_VALUES.category01,
  AGGREGATION_AXIS_COLUMN_VALUES.category02,
  AGGREGATION_AXIS_COLUMN_VALUES.month,
  AGGREGATION_AXIS_COLUMN_VALUES.day,
  AGGREGATION_AXIS_COLUMN_VALUES.wday,
];

export const UNSELECTABLE_SORT_COLUMNS = [
  AGGREGATION_AXIS_COLUMN_VALUES.projectId,
  AGGREGATION_AXIS_COLUMN_VALUES.projectName,
];

export const FILTER_COMPARISON_OPERATORS = {
  equals: 'equals',
  notEquals: 'not_equals',
  contains: 'contains',
  notContains: 'not_contains',
  greaterThan: 'greater_than',
  lessThan: 'less_than',
  greaterThanOrEqual: 'greater_than_or_equal',
  lessThanOrEqual: 'less_than_or_equal',
  startsWith: 'starts_with',
  endsWith: 'ends_with',
};

export const DEFAULT_FILTER_CONDITION = {
  id: '',
  targetColumn: AGGREGATION_AXIS_COLUMN_VALUES.channel,
  condition: FILTER_COMPARISON_OPERATORS.equals,
  value: '',
};

export const DEFAULT_SORT_FIELD = {
  id: '',
  targetColumn: '',
  isAsc: true,
};

export const OUTPUT_COLUMN_TABS = {
  aggregationAxis: 'aggregationAxis',
  advertisingTitle: 'advertisingTitle',
  other: 'other',
};

export const SORT_DIRECTION_OPTION_VALUES = {
  asc: true,
  desc: false,
};

export const INTERVAL_OPTION_VALUES = {
  once: 'once',
  monthly: 'monthly',
  weekly: 'weekly',
  daily: 'daily',
};

// Panels
export const MAX_PANELS_PER_SHEET = 500;
export const STRING_CONTENT_VARIABLE_OPTION_VALUES = {
  exportDateTime: '{{export_datetime}}',
  startYear: '{{start_year}}',
  startMonth: '{{start_month}}',
  startDay: '{{start_day}}',
  endYear: '{{end_year}}',
  endMonth: '{{end_month}}',
  endDay: '{{end_day}}',
};

export const DAY_OF_WEEK_OPTION_VALUES = {
  monday: 'monday',
  tuesday: 'tuesday',
  wednesday: 'wednesday',
  thursday: 'thursday',
  friday: 'friday',
  saturday: 'saturday',
  sunday: 'sunday',
};

export const STATUS_VALUES = {
  valid: 'active',
  invalid: 'inactive',
};

export const DEFAULT_PANEL_VALUE = {
  id: '',
  name: '',
  type: EXPORT_TYPE_OPTION_VALUES.table,
  column: '',
  row: '',
  showHeaderRow: SHOW_HEADER_ROW_OPTION_VALUES.show,
  content: '',
  numberOfMaxLines: '',
  period: PERIOD_OPTION_VALUES.today,
  startedOn: null,
  endedOn: null,
  columns: [],
  filters: [],
  sorts: [],
};

export const DEFAULT_SPREADSHEET_REPORT_CONFIGS = {
  sheetId: '',
  name: '',
  status: STATUS_VALUES.valid,
  period: PERIOD_OPTION_VALUES.this_month,
  startDate: null,
  endDate: null,
  panels: {
    items: {},
    sortedPanelKeys: [],
  },
  schedules: {
    interval: INTERVAL_OPTION_VALUES.once,
  },
};

export const PERIOD_THRESHOLD_DAYS = 93;
